import * as SavePanel from "../../../src/Components/SavePanel/SavePanel.scss";
import * as react from "react";
import { Size, getMaterialIconBySize, dotsLoading } from "../../ViewUtils.js";
import { toString } from "../../fable_modules/fable-library.3.7.20/Types.js";
import { mapIndexed } from "../../fable_modules/fable-library.3.7.20/List.js";
import { stripHtmlTags } from "../../Utils.js";


function getLeftIcon(index, status) {
    let iconHtml;
    switch (status.tag) {
        case 1: {
            const children_4 = [react.createElement("div", {}, dotsLoading)];
            iconHtml = react.createElement("span", {
                className: "save-panel__icon save-panel__icon--saving",
            }, ...children_4);
            break;
        }
        case 2: {
            const children_6 = [getMaterialIconBySize("done", new Size(3))];
            iconHtml = react.createElement("span", {
                className: "save-panel__icon",
            }, ...children_6);
            break;
        }
        case 3: {
            const children_8 = [getMaterialIconBySize("clear", new Size(3))];
            iconHtml = react.createElement("span", {
                className: "save-panel__icon",
            }, ...children_8);
            break;
        }
        default: {
            const children = [toString(index)];
            iconHtml = react.createElement("span", {
                className: "save-panel__icon save-panel__icon--not-saving",
            }, ...children);
        }
    }
    return react.createElement("div", {
        className: "save-panel__icon-container",
    }, iconHtml);
}

export function getSavePanel(heading, saveItems) {
    let children_13;
    const children_15 = [react.createElement("h3", {
        className: "save-panel__heading",
    }, heading), (children_13 = mapIndexed((index, saveItem) => {
        let children_7, children_5;
        let failMsgHtml;
        const matchValue = saveItem[1];
        switch (matchValue.tag) {
            case 1:
            case 2: {
                failMsgHtml = react.createElement(react.Fragment, {});
                break;
            }
            case 3: {
                const children_1 = [stripHtmlTags(matchValue.fields[0].split(""))];
                failMsgHtml = react.createElement("div", {
                    className: "save-item__container save-item__container--fail-msg",
                }, ...children_1);
                break;
            }
            default: {
                failMsgHtml = react.createElement(react.Fragment, {});
            }
        }
        const children_9 = [getLeftIcon(index + 1, saveItem[1]), (children_7 = [(children_5 = [react.createElement("span", {}, saveItem[0])], react.createElement("div", {
            className: "save-item__container",
        }, ...children_5)), failMsgHtml], react.createElement("div", {
            className: "d-flex flex-column w-100",
        }, ...children_7))];
        return react.createElement("div", {
            className: "save-panel__save-item",
        }, ...children_9);
    }, saveItems), react.createElement("div", {
        className: "save-panel__main-container",
    }, ...children_13))];
    return react.createElement("div", {
        className: "save-panel",
    }, ...children_15);
}

